import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
const ResendIcon = (props: SvgProps) => (
  <Svg width={24} height={24} fill='none' {...props}>
    <Path
      fill='#000'
      d='M12.088 18.861c-1.923 0-3.55-.664-4.88-1.993-1.33-1.33-1.996-2.951-1.996-4.866 0-1.916.666-3.538 1.996-4.868 1.33-1.33 2.957-1.996 4.881-1.996 1.18 0 2.284.282 3.31.846a6.575 6.575 0 0 1 2.475 2.366V5.138h.923V10.2h-5.062v-.923h3.624a5.905 5.905 0 0 0-2.185-2.355 5.794 5.794 0 0 0-3.084-.86c-1.655 0-3.061.578-4.218 1.736-1.158 1.157-1.737 2.559-1.737 4.205s.578 3.047 1.733 4.202c1.156 1.156 2.562 1.733 4.218 1.733a5.81 5.81 0 0 0 3.437-1.084 5.77 5.77 0 0 0 2.158-2.87h.981c-.43 1.46-1.252 2.639-2.465 3.534-1.213.896-2.583 1.343-4.109 1.343Z'
    />
  </Svg>
);
export default ResendIcon;
